// /console entry: builds Supabase auth + console API from public build config.
import { useCallback, useMemo } from 'react';
import { resolveApiBase } from '../lib/config.ts';
import { Empty, ToastProvider } from '../ui/index.tsx';
import { createConsoleApi } from './api.ts';
import { supabaseConsoleAuth } from './auth.ts';
import { ConsoleRoot } from './ConsoleRoot.tsx';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export function ConsoleEntry() {
  const config = useMemo(() => {
    try {
      if (!SUPABASE_URL || !SUPABASE_ANON_KEY) throw new Error('VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set');
      return { apiBase: resolveApiBase({ PROD: import.meta.env.PROD, VITE_API_BASE: import.meta.env.VITE_API_BASE as string | undefined }), error: null };
    } catch (e) {
      return { apiBase: '', error: (e as Error).message };
    }
  }, []);
  const auth = useMemo(() => (config.error ? null : supabaseConsoleAuth(SUPABASE_URL as string, SUPABASE_ANON_KEY as string)), [config.error]);
  const makeApi = useCallback((getToken: () => Promise<string | null>) => createConsoleApi({ baseUrl: config.apiBase, getToken }), [config.apiBase]);
  if (config.error || !auth) return <div className="app"><Empty title="คอนโซลยังตั้งค่าไม่ครบ" text={config.error ?? ''} /></div>;
  return <ToastProvider><ConsoleRoot auth={auth} makeApi={makeApi} /></ToastProvider>;
}
